import React, { useState, useEffect, useRef } from 'react';
import Button from '../components/Button';
import Typed from 'react-typed';
import Particles from 'react-particles-js';
import jamie2 from '../img/jamie-photoshoot.png';

import { Link } from 'react-router-dom';

import 'react-typed/dist/animatedCursor.css';
import '../css/homepage.css';

function Homepage(props) {
  const textContent = useRef();
  const [debouncer, setDebouncer] = useState();

  const transitionText = () => {
    setDebouncer(true);
  };

  useEffect(() => {
    setTimeout(transitionText, 300);
  }, []);

  return (
    <section id='homepage'>
      <Particles
        params={{
          interactivity: {
            detect_on: 'canvas',
            events: {
              onhover: {
                enable: true,
                mode: 'repulse'
              },
              onClick: {
                enable: true,
                mode: 'repulse'
              }
            }
          },
          particles: {
            number: {
              value: 50
            },
            opacity: {
              value: 1
            },
            line_linked: {
              opacity: 0.5,
              distance: 30,
              shadow: {
                enable: true,
                color: '#0068FF',
                blur: 1
              }
            }
          }
        }}
      />
      <div className='home-content'>
        <div
          ref={textContent}
          className={`home-text ${debouncer ? 'move-text' : ''}`}
        >
          <h2 className='home-title'>
            <Typed
              strings={[`You don't <span class='text-style'> know </span> me`]}
              typeSpeed={90}
              startDelay={500}
            />
          </h2>
          <p className='home-sub-title'>
            {' '}
            <Typed
              strings={[`You're about to...`]}
              typeSpeed={65}
              startDelay={3650}
            />
          </p>
          <Link onClick={() => props.setSelected('projects')} to='/projects'>
            <Button buttonClass='homepage-button' value='See My Projects' />
          </Link>
        </div>
        <div className='particle-cont'>
          <img src={jamie2} alt='' />
        </div>
      </div>
    </section>
  );
}

export default Homepage;
